// Libs
import { TFunction } from 'i18next';
import * as yup from 'yup';
// Others
import { IFormClient } from '~/utils/interface/client';
import { EMPTY_STRING, REG_EXP } from '~/utils/constants/common';

export const schema = (t: TFunction): yup.ObjectSchema<IFormClient> => {
  return yup.object().shape({
    firstName: yup
      .string()
      .trim()
      .test(
        'client-firstname-or-entity',
        t('common_validate_client_name_quired', { ns: 'common/base' }),
        function (value) {
          const { companyName } = this.parent;

          if (!value && !companyName) {
            return this.createError({
              path: 'firstName',
              message: t('common_validate_client_name_quired', { ns: 'common/base' }),
            });
          }

          return true;
        }
      )
      .optional(),
    lastName: yup.string().trim().optional(),
    entityName: yup.string().trim().optional(),
    companyName: yup
      .string()
      .trim()
      .optional()
      .test(
        'client-entity-or-firstname',
        t('common_validate_client_name_quired', { ns: 'common/base' }),
        function (value) {
          const { firstName } = this.parent;

          if (!value && !firstName) {
            return this.createError({
              path: 'companyName',
              message: t('common_validate_client_name_quired', { ns: 'common/base' }),
            });
          }

          return true;
        }
      ),
    clientContacts: yup.array().of(
      yup.object().shape({
        email: yup
          .string()
          .trim()
          .test('isValidEmail', t('common_validate_invalid_email', { ns: 'common/base' }), (value) => {
            if (value && !REG_EXP.EMAIL.test(value)) return false;
            return true;
          })
          .optional(),
        phoneNumber: yup
          .string()
          .trim()
          .test('phone-length', t('common_validate_invalid_phone', { ns: 'common/base' }), (value) => {
            if (!value) return true;
            const phoneNumber = value?.replace(REG_EXP.NUMBER, EMPTY_STRING);
            return REG_EXP.PHONE_NUMBER.test(phoneNumber);
          })
          .optional(),
      })
    ),
    emailContact: yup
      .string()
      .trim()
      .test('isValidEmail', t('common_validate_invalid_email', { ns: 'common/base' }), (value) => {
        if (value && !REG_EXP.EMAIL.test(value)) return false;
        return true;
      })
      .optional(),
    phoneNumberContact: yup
      .string()
      .trim()
      .test('phone-length', t('common_validate_invalid_phone', { ns: 'common/base' }), (value) => {
        if (!value) return true;
        const phoneNumber = value?.replace(REG_EXP.NUMBER, EMPTY_STRING);
        return REG_EXP.PHONE_NUMBER.test(phoneNumber);
      })
      .optional(),
    type: yup.string().trim().optional(),
    paymentTerms: yup.string().trim().optional(),
    note: yup.string().trim().optional(),
    assignedAccountId: yup.string().trim().optional(),
    title: yup.string().trim().optional(),
    businessType: yup.string().trim().optional(),
    address: yup.string().trim().optional(),
    unitDetail: yup.string().trim().optional(),
    city: yup.string().trim().optional(),
    state: yup.string().trim().optional(),
    postalCode: yup.string().trim().optional(),
    country: yup.string().trim().optional(),
    lat: yup.string().trim().optional(),
    lng: yup.string().trim().optional(),
    additionalContact: yup.array().of(
      yup.object().shape({
        email: yup
          .string()
          .trim()
          .test(
            'isValidEmail',
            t('common_validate_invalid_email', { ns: 'common/base' }),
            (value) => !value || REG_EXP.EMAIL.test(value)
          ),
        phoneNumber: yup
          .string()
          .trim()
          .test('phone-length', t('common_validate_invalid_phone', { ns: 'common/base' }), (value) => {
            if (!value) return true;
            const phoneNumber = value.replace(REG_EXP.NUMBER, EMPTY_STRING);
            return REG_EXP.PHONE_NUMBER.test(phoneNumber);
          })
          .optional(),
      })
    ),
    avatarImage: yup.object().optional(),
    salesAccountId: yup.string().trim().optional(),
    isDeleteAvatar: yup.boolean().optional(),
  });
};

export const defaultValuesClientForm: IFormClient = {
  type: EMPTY_STRING,
  assignedAccountId: EMPTY_STRING,
  firstName: EMPTY_STRING,
  lastName: EMPTY_STRING,
  title: EMPTY_STRING,
  companyName: EMPTY_STRING,
  businessType: EMPTY_STRING,
  address: EMPTY_STRING,
  unitDetail: EMPTY_STRING,
  city: EMPTY_STRING,
  state: EMPTY_STRING,
  postalCode: EMPTY_STRING,
  country: EMPTY_STRING,
  lat: EMPTY_STRING,
  lng: EMPTY_STRING,
  entityName: EMPTY_STRING,
  salesAccountId: EMPTY_STRING,
  note: EMPTY_STRING,
  isDeleteAvatar: false,
  clientContacts: [],
  additionalContact: [
    {
      email: EMPTY_STRING,
    },
  ],
  avatarImage: {},
};
